import { XSensationResponse } from '@/types/x';
import { atom } from 'jotai';

export const xAtom = atom<XSensationResponse | undefined>(undefined);
